import React, { FC } from 'react';

import { Button } from 'components';
import {
  IconCloud,
  IconNoDataSale,
  IconTechnology,
  IncognitoIcon,
} from 'icons';
import { useTranslations } from 'context/translations';
import { LandingPageLinkKeys, LandingPageTextKeys } from 'service';

import styles from './TrustUsBlock.module.css';

export const TrustUsBlock: FC = () => {
  const { t, link } = useTranslations();
  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div>
          <h2>{t(LandingPageTextKeys.TrustUsBlockTitle)}</h2>
          <div>{t(LandingPageTextKeys.TrustUsBlockDescription)}</div>
          <Button
            size="small"
            view="secondary"
            className={styles.button}
            to={link(LandingPageLinkKeys.LearnMoreLink)}
          >
            {t(LandingPageTextKeys.TrustUsBlockButton)}
          </Button>
        </div>
        <div className={styles.separator} />
        <div className={styles.feature_container}>
          <div>{t(LandingPageTextKeys.TrustUsBlockFeature0)}</div>
          <div>{t(LandingPageTextKeys.TrustUsBlockFeature1)}</div>
          <div>{t(LandingPageTextKeys.TrustUsBlockFeature2)}</div>
        </div>
      </div>

      <div className={styles.bottom}>
        <div>
          <IconTechnology />
          {t(LandingPageTextKeys.TrustUsBlockCard0Description)}
        </div>
        <div>
          <IconCloud />
          {t(LandingPageTextKeys.TrustUsBlockCard1Description)}
        </div>
        <div>
          <IconNoDataSale />
          {t(LandingPageTextKeys.TrustUsBlockCard2Description)}
        </div>
        <div>
          <IncognitoIcon />
          {t(LandingPageTextKeys.TrustUsBlockCard3Description)}
        </div>
      </div>
    </div>
  );
};
